module.exports = __webpack_public_path__ + "img/prop-tree-2-right.25272eea.png";